import antdTheme from 'ant-design-vue/es/theme';

/**
 * 資產負債／後台主色：白金 × 深金
 */
export const adminAntdTheme = {
    algorithm: antdTheme.defaultAlgorithm,
    components: {
        // 覆寫 Layout 內建預設（否則 a-layout-header 會強制 #001529 蓋過 Tailwind）
        Layout: {
            colorBgHeader: 'rgba(255, 255, 255, 0.96)',
            colorBgTrigger: '#f3f0ea'
        }
    },
    token: {
        colorPrimary: '#C4A35A',
        colorPrimaryHover: '#B8923E',
        colorPrimaryActive: '#8B6914',
        colorLink: '#8B6914',
        colorLinkHover: '#6B5428',
        colorInfo: '#A8894A',
        colorWarning: '#D4A017',
        // 成功／啟用：較鮮明的綠（過深會讓 Tag 淡底看起來發灰）
        colorSuccess: '#16A34A',
        borderRadius: 10,
        borderRadiusLG: 14,
        fontFamily:
            "'Noto Sans TC', Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }
};
